import { EndpointKeys } from '../config/api';
import ApiService from './api';

export const clientService = {
  async getInvoicePaymentLink(invoiceId: number): Promise<{
    payment_url: string;
    amount: number;
    currency: string;
    payment_methods: string[];
    status: string;
  }> {
    return ApiService.request<{
      payment_url: string;
      amount: number;
      currency: string;
      payment_methods: string[];
      status: string;
    }>(
      EndpointKeys.INVOICE_PAYMENT_LINK,
      {
        urlParams: { invoiceId: invoiceId.toString() }
      }
    );
  }
}; 